import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';

const PaymentSuccess = () => {
  return (
    <div className="main-content">
      <div className="auth-container">
        <div className="auth-card" style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '5rem', marginBottom: '20px' }}>🎉</div>
          <h1 className="auth-title">Payment Successful!</h1>
          <p className="auth-subtitle">
            Your credits have been added to your account. You're ready to spread Christmas cheer!
          </p>
          <div style={{ marginTop: '30px', display: 'flex', gap: '15px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/send" className="btn btn-primary">
              ✉️ Send a Message
            </Link>
            <Link to="/dashboard" className="btn btn-secondary">
              📊 Go to Dashboard
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

const PaymentCancel = () => {
  return (
    <div className="main-content">
      <div className="auth-container">
        <div className="auth-card" style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '5rem', marginBottom: '20px' }}>😔</div>
          <h1 className="auth-title">Payment Cancelled</h1>
          <p className="auth-subtitle">
            Your payment was cancelled. No worries - you can try again when you're ready!
          </p>
          <div style={{ marginTop: '30px', display: 'flex', gap: '15px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/credits" className="btn btn-primary">
              🎁 Try Again
            </Link>
            <Link to="/dashboard" className="btn btn-outline">
              📊 Go to Dashboard
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export { PaymentSuccess, PaymentCancel };
